<template>
	<div class="promo__list__item">
		<img
			class="global-card__img"
			v-if="promo.image_url !== null"
			:src="promo.image_url"
			:alt="promo.promo_name"
			@error="onImageError"
		/>
		<div
			class="global-card__wrapper"
			:class="promo.selected && !expired ? 'global-card__grayout' : ''"
		>
			<div class="promo__list__rewards__header">
				<h2>
					{{ promo.promo_name }}
				</h2>
			</div>
			<div class="promo__list__rewards__body">
				<template v-if="promo.description">
					<p
						class="promo__list__rewards__body--description"
						v-for="(desc, idx) in promo.description.split('\n')"
						:key="idx"
					>
						{{ desc }}
					</p>
					<rules-indicator
						:rules="promo.rules"
						v-if="!expired && started && !promo.opted_in"
					/>
					<div class="underline" style="margin: 15px 0; width: 50px"></div>
				</template>

				<div class="promo__list__rewards__body--time">
					<span v-if="startsOn !== null && !started">
						Starts
						{{ startsOn }}
					</span>
					<span v-if="expiringOn !== null && started">
						<span v-if="expired">Expired</span>
						<span v-else>Expiring</span>
						{{ expiringOn }}
					</span>
				</div>
			</div>
			<div class="underline"></div>
			<div class="promo__list__rewards__footer">
				<div v-if="!expired && started">
					<div v-if="!promo.opted_in">
						<b-button
							v-if="!selected"
							class="button button__default"
							:title="'Opt In'"
							:loading="false"
							@click="optIn"
						/>
						<b-button
							v-else
							class="button button__default"
							:title="'Opt Out?'"
							:loading="false"
							@click="optOut"
							style="color: var(--gray)"
						/>
					</div>
					<div v-else>
						<b-button
							class="button button__default"
							:title="'Already opted in'"
							:loading="false"
							:disabled="true"
							style="color: var(--red)"
						/>
					</div>
				</div>
				<div v-else-if="!started">
					<b-button
						class="button button__default"
						:title="'Not Started'"
						:loading="false"
						style="color: var(--red)"
					/>
				</div>
				<div v-else>
					<b-button
						class="button button__default"
						:title="'Expired'"
						:loading="false"
						style="color: var(--red)"
					/>
				</div>
				<router-link
					:to="{
						name: 'free-bets-offer-single',
						params: { promoId: promo.promos_id },
					}"
					v-if="!expired"
				>
					<span>Tell me more</span>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import RulesIndicator from "./RulesIndicator.vue";
export default {
	components: { RulesIndicator },
	props: {
		promo: {
			type: Object,
			required: true,
		},
	},
	computed: {
		selected() {
			let vm = this;
			return (
				vm.$store.getters["promos/optedInPromo"].findIndex((promo) => {
					return promo.promos_id == vm.promo.promos_id;
				}) > -1
			);
		},

		expired() {
			return this.$moment(this.promo.end_time).isBefore(new Date());
		},
		expiringSoon() {
			// Human redable time
			let isExpiringSoon = false;

			//expiring soon
			if (this.$moment().diff(this.$moment(this.promo.end_time), "days") <= 2) {
				let end = this.$moment()
					.add(2, "days")
					.endOf("day");

				if (this.$moment(this.promo.end_time).isBefore(end)) {
					isExpiringSoon = true;
				}
			}
			return isExpiringSoon;
		},
		started() {
			return this.$moment(new Date()).isAfter(this.promo.start_time);
		},
		startsOn() {
			let startsOn = null;

			//expiring on
			startsOn = this.$moment(this.promo.start_time).calendar(null, {
				sameDay: "[today at] LT",
				nextDay: "[tomorrow at] LT",
				lastDay: "[yesterday at] LT",
				lastWeek: "[on] Do of MMM YYYY [at] LT", //[last] on
				nextWeek: "[on] Do of MMM YYYY [at] LT",
				sameElse: "[on] Do of MMM YYYY [at] LT",
			});
			return startsOn;
		},
		expiringOn() {
			let isExpiringOn = null;

			//expiring on
			isExpiringOn = this.$moment(this.promo.end_time).calendar(null, {
				sameDay: "[today at] LT",
				nextDay: "[tomorrow at] LT",
				lastDay: "[yesterday at] LT",
				lastWeek: "[on] Do of MMM YYYY [at] LT", //[last] on
				nextWeek: "[on] Do of MMM YYYY [at] LT",
				sameElse: "[on] Do of MMM YYYY [at] LT",
			});
			return isExpiringOn;
		},
	},
	methods: {
		onImageError(e) {
			e.target.style.display = "none";
		},
		optIn() {
			let vm = this;

			vm.$store.dispatch("promos/optInPromo", vm.promo);
			vm.$store.dispatch("freebets/removeAppliedFreebet", {});
		},
		optOut() {
			let vm = this;

			vm.$store.dispatch("promos/optOutPromo", vm.promo.promos_id);
			vm.$store.dispatch("freebets/removeAppliedFreebet", {});
		},
	},
};
</script>

<style></style>
